(function (global, factory) {
    factory(require('jquery'))
}(this, (function ($) { 'use strict'

    global.Search = {
        options: {
            department: null,
            page: {
                service: null,
                address: null,
                autocomplete: null,
            },
            off_canvas: {
                service: null,
                address: null,
                autocomplete: null,
            },
            header: {
                service: null,
                address: null,
                autocomplete: null,
            },
            empty: {
                address: null,
                autocomplete: null,
            },
            request: {
                address: null,
                autocomplete: null,
            }
        },
        newGoogleMaps: target => new google.maps.places.Autocomplete(
            Search.options[target].address,
            {
                componentRestrictions: { country: ["it"] },
                fields: ["address_components", "geometry"],
                types: ["address"],
            }
        ),
        fillInPage: function() { Search.fillInAddress('page') },
        fillInOffCanvas: function() { Search.fillInAddress('off_canvas') },
        fillInHeader: function() { Search.fillInAddress('header') },
        fillInEmpty: function() { Search.fillInAddress('empty') },
        fillInRequest: function() { Search.fillInAddress('request') },
        fillInAddress: function (target) {
            const place = Search.options[target].autocomplete.getPlace()

            if (place.geometry !== undefined) {
                const location = place.geometry.location
                let street, number

                document.querySelectorAll("[name='l']").forEach((item) => {
                    item.value = location.lat() + '|' + location.lng()
                })

                for (const component of place.address_components) {
                    switch (component.types[0]) {
                        case "street_number": {
                            number = component.long_name
                            break
                        }

                        case "route": {
                            street = component.long_name
                            break
                        }

                        case "locality":
                            document.querySelectorAll("[name='c']").forEach((item) => {
                                item.value = component.long_name
                            })
                            break

                        case "administrative_area_level_2":
                            document.querySelectorAll("[name='p']").forEach((item) => {
                                item.value = component.short_name
                            })
                            break

                        case "postal_code": {
                            document.querySelectorAll("[name='z']").forEach((item) => {
                                item.value = component.long_name
                            })
                            break
                        }

                        case "country":
                            document.querySelectorAll("[name='n']").forEach((item) => {
                                item.value = component.long_name
                            })
                            break
                    }
                }
                document.querySelectorAll("[name='a']").forEach((item) => {
                    item.value = street
                })
                if (number) {
                    document.querySelectorAll("[name='a']").forEach((item) => {
                        item.value += ', ' + number
                    })
                }

                ['page', 'off_canvas', 'header', 'empty', 'request'].forEach(section => {
                    if (target !== section && Search.options[section].address !== null)
                        Search.options[section].address.value = Search.options[target].address.value
                })

                if (target !== 'empty' && target !== 'request' && Search.options[target].service.value !== '') {
                    Search.options[target].address.form.submit()
                }
            }
        },
        addToSearch: function (section, searchFunction, hasService) {
            const prefix = section.charAt(0).toLowerCase()
            if (hasService) {
                Search.options[section].service = document.getElementById(prefix + "_service")
            }
            Search.options[section].address = document.getElementById(prefix + "_address")
            Search.options[section].autocomplete = Search.newGoogleMaps(section)
            Search.options[section].autocomplete.addListener("place_changed", searchFunction)
            Search.options[section].address.addEventListener('keydown', function(e) {
                if (e.keyCode === 13) e.preventDefault()
            })
        },
        autocomplete: function() {
            const pageForm = document.getElementById('p-form-search')
            if (pageForm) {
                Search.addToSearch('page', Search.fillInPage, true)
            }

            Search.addToSearch('off_canvas', Search.fillInOffCanvas, true)

            Search.addToSearch('header', Search.fillInHeader, true)

            const emptyForm = document.getElementById('e-form-search')
            if (emptyForm) {
                Search.addToSearch('empty', Search.fillInEmpty, false)
            }

            const requestForm = document.getElementById('form-request')
            if (requestForm) {
                Search.addToSearch('request', Search.fillInRequest, false)
            }
        },
        isVisible: function (element, parent) {
            const offset = 100
            const parentScrollTop = parent.scrollTop + offset
            const parentBottom = parentScrollTop + parent.offsetHeight - offset
            const elementTop = element.offsetTop
            const elementBottom = elementTop + element.offsetHeight

            return !((elementBottom < parentScrollTop) || (parentBottom < elementTop))
        },
        scroll: function(e) {
            let found = false
            const active = document.querySelector("[data-s-scroll].active")
            e.target.querySelectorAll('.s-container').forEach(element => {
                if (found) return

                const scrollable = document.getElementById('s-scrollable')
                if (scrollable.offsetHeight + scrollable.scrollTop !== scrollable.scrollHeight) {
                    if (Search.isVisible(element, e.target) && Search.options.department !== active.id) {
                        active.classList.remove('active')
                        Search.options.department = element.id
                        const dataScroll = document.querySelector("[data-s-scroll='" + element.id + "']")
                        dataScroll.classList.add('active')
                        document.getElementById("categories").querySelector('.list')
                            .scroll({left: dataScroll.offsetLeft - 16, behavior: 'smooth'})
                        found = true
                    }
                } else {
                    const last = document.querySelector('.s-container:last-of-type')
                    active.classList.remove('active')
                    Search.options.department = last.id
                    document
                        .querySelector("[data-s-scroll='" + last.id + "']")
                        .classList.add('active')
                    found = true
                }
            })
        },
        init: function() {
            document.querySelectorAll('.form-service').forEach(element => {
                element.addEventListener('click', function (e) {
                    (new bootstrap.Modal(document.getElementById('modal-search'), {
                        keyboard: false
                    })).show()
                })
            })

            document.querySelectorAll('[data-s-scroll]').forEach(element => {
                element.addEventListener('click', function (e) {
                    e.preventDefault()
                    const target = e.target.getAttribute('data-s-scroll')
                    const offset = document.querySelector(`#s-scrollable #${target}`)
                        .offsetTop

                    document.getElementById('s-scrollable')
                        .scroll({top: offset - 24, behavior: 'smooth'})
                })
            })

            document.getElementById('s-scrollable').addEventListener('scroll', Search.scroll)

            document.getElementById('service_search').addEventListener('keyup', e => {
                const elements = document.getElementById('s-scrollable').querySelectorAll('a')

                elements.forEach(element => {
                    if (element.textContent.trim().toLowerCase().indexOf(e.target.value.toLowerCase()) >= 0) {
                        element.setAttribute('style', 'display:block !important')
                    } else {
                        element.setAttribute('style', 'display:none !important')
                    }
                })

                document.querySelectorAll('.s-container').forEach(element => {
                    const filtered = Array.prototype.filter.call(
                        element.querySelectorAll('a'),
                        link => {
                            return link.style.display === 'block'
                        }
                    )
                    const menu = document.querySelector("[data-s-scroll='" + element.id + "']")
                    const style = filtered.length ? 'block' : 'none'
                    element.setAttribute('style', `display:${style} !important`)
                    menu.setAttribute('style', `display:${style} !important`)
                })
                document.getElementById('s-scrollable').dispatchEvent(new Event("scroll"))
            })

            document.querySelectorAll('[data-s-department]').forEach(element => {
                element.addEventListener('click', e => {
                    e.preventDefault()
                    const label = e.target.textContent.trim()
                    const id = e.target.getAttribute('data-s-department')

                    document.querySelectorAll("[name='d']").forEach(i => { i.value = id })
                    document.querySelectorAll("[name='s']").forEach(i => { i.value = '' })
                    document.querySelectorAll("[id$=_service]").forEach(i => { i.value = label })
                    bootstrap.Modal.getInstance(document.getElementById('modal-search')).hide()
                })
            })

            document.querySelectorAll('[data-s-service]').forEach(element => {
                element.addEventListener('click', e => {
                    e.preventDefault()
                    const label = e.target.textContent.trim()
                    const id = e.target.getAttribute('data-s-service')

                    document.querySelectorAll("[name='s']").forEach(i => { i.value = id })
                    document.querySelectorAll("[name='d']").forEach(i => { i.value = '' })
                    document.querySelectorAll("[id$=_service]").forEach(i => { i.value = label })
                    bootstrap.Modal.getInstance(document.getElementById('modal-search')).hide()
                })
            })
        }
    }

})))
